/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  TaskManagerConsoleService,
  PagedResultDto_TaskManagerConsoleListDto,
} from '../../services/wealthlane-task-manager-services';

const useGetTmcList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<PagedResultDto_TaskManagerConsoleListDto | undefined, unknown> => {
  const {
    createdFromDate,
    createdToDate,
    taskTypeId,
    reportStatusId,
    createdById,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    _force,
  } = tableInfo;
  const tmcList = useQuery(['getTmcList', tableInfo], async () => {
    return await handleRequest(
      TaskManagerConsoleService.getApiTaskmanagerApiAppTaskManagerConsoleTaskManagerConsoleList(
        createdFromDate,
        createdToDate,
        taskTypeId,
        reportStatusId,
        createdById,
        filter,
        sorting,
        skipCount,
        maxResultCount
      )
    );
  });

  return tmcList;
};

export default useGetTmcList;
